import { combineReducers } from "redux";
import constants from "./constants";
import createApiReducer from "reducers/createReducers";

const reducers = combineReducers({
  performanceList: createApiReducer(constants.GET_PERFORMANCE_LIST, []),
  performanceVersus: createApiReducer(constants.GET_PERFORMANCE_VERSUS, []),
  fbdashboardList: createApiReducer(constants.GET_FBDASHBOARD_LIST, []),
  fbreportList: createApiReducer(constants.GET_FBREPORT_LIST, []),
  fbgraphList: createApiReducer(constants.GET_FBGRAPH_LIST, []),
  gdashboardList: createApiReducer(constants.GET_GDASHBOARD_LIST, []),
  greportList: createApiReducer(constants.GET_GREPORT_LIST, []),
  ggraphList: createApiReducer(constants.GET_GGRAPH_LIST, []),
});

export default reducers;
